// extracted by mini-css-extract-plugin
export var boxesQuantityContainer = "giftCardSelector_boxesQuantityContainer__V7g8z";
export var container = "giftCardSelector_container__3V1-J";
export var item = "giftCardSelector_item__yhvpZ";
export var itemContainer = "giftCardSelector_itemContainer__deJvQ";
export var selected = "giftCardSelector_selected__FVhkv";